<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "TradeReportLayout"
    }
</script>

<style scoped>

</style>
